// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cropper__wrapper[data-v-0e4e53f2]{position:relative}.cropper__btns[data-v-0e4e53f2]{bottom:20px;gap:4px;left:0;position:absolute;right:0}.cropper__overlay[data-v-0e4e53f2]{bottom:0;left:0;position:absolute;right:0;top:0}.icon-rotate[data-v-0e4e53f2]{transform:scaleX(-1) rotate(-90deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
